module.exports = __webpack_public_path__ + "img/qmr2.4cd59185.jpg";